import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {UserService} from '../../../services/user/user.service';

@Component({
  selector: 'app-user-info-qr',
  styleUrls: ['./user-info-qr.component.scss'],
  templateUrl: './user-info-qr.component.html'
})
export class UserInfoQrComponent implements OnInit {

  private userId: number;
  public imageURL: SafeUrl;

  constructor(private activatedRoute: ActivatedRoute,
              private sanitizer: DomSanitizer,
              private userService: UserService) {
    this.userId = activatedRoute.snapshot.params.userId;
  }

  ngOnInit(): void {
    this.userService.qrInfo(this.userId).subscribe(blob => {
      this.imageURL = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
    });
  }
}
